import * as React from 'react';

import { cn } from '@/lib/utils';
import { useFieldHighlight } from '@/contexts/FieldHighlightContext';

interface InputProps extends React.ComponentProps<'input'> {
  fieldPath?: string;
}

function Input({ className, type, fieldPath, ...props }: InputProps) {
  const { highlightedFieldPaths } = useFieldHighlight();
  const isHighlighted = fieldPath && highlightedFieldPaths.has(fieldPath);

  return (
    <input
      type={type}
      data-slot="input"
      data-fieldpath={fieldPath}
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground/60 selection:bg-primary selection:text-primary-foreground border-input h-7 w-full min-w-0 rounded-md border bg-transparent px-2 py-0.5 text-sm shadow-xs transition-all duration-200 outline-none file:inline-flex file:h-5 file:border-0 file:bg-transparent file:text-xs file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[2px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        isHighlighted && 'field-highlight',
        className
      )}
      {...props}
    />
  );
}

export { Input };
